import React from 'react';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { LithiumBatteryWithEquipment } from './LithiumBatteryWithEquipment';
import { LithiumBatteryInEquipment } from './LithiumBatteryInEquipment';
import { MetalBatteryWithEquipment } from './MetalBatteryWithEquipment';

function BatchBatteryDeclarationComplete(props: RenderBatchSectionType) {
	const { currentBatchData } = useForwardingBatchProvider();

	return (
		<div>
			<h5 className='mb-xs'>{props.section.name}</h5>

			{currentBatchData?.batteryDetails?.lithiumBatteriesWithEquipment && (
				<LithiumBatteryWithEquipment
					onChangeCallback={() => null}
					complete={props.complete}
					readOnly={props.readOnly}
					defaultSelected={false}
				/>
			)}

			{currentBatchData?.batteryDetails?.lithiumBatteriesInEquipment && (
				<LithiumBatteryInEquipment
					onChangeCallback={() => null}
					complete={props.complete}
					readOnly={props.readOnly}
					defaultSelected={false}
				/>
			)}

			{currentBatchData?.batteryDetails?.metalBatteriesWithEquipment && (
				<MetalBatteryWithEquipment
					onChangeCallback={() => null}
					complete={props.complete}
					readOnly={props.readOnly}
					defaultSelected={false}
				/>
			)}
		</div>
	);
}

export { BatchBatteryDeclarationComplete };
